import { render, staticRenderFns } from "./escapeRoutes.vue?vue&type=template&id=7053d26f"
import script from "./escapeRoutes.vue?vue&type=script&lang=js"
export * from "./escapeRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports